import {formatNumber} from '../../../library/numberFunction';
import {formatDate} from './subscriptionUtils';
import {SubscriptionPlan} from '../../../redux/subscription/subscription.type';

export const calculateSalesFraction = (plan: SubscriptionPlan): string => {
    const salesQuantity = plan.amount - plan.amountAvailable || 0;
    const totalQuantity = plan.amount || 0;
    return `${salesQuantity}/${totalQuantity}`;
};

export const calculatePriceRange = (plan: SubscriptionPlan): string => {
    const prices = plan.prices || [];
    if(prices.length === 0) return '-';
    const minPrice = Math.min(...prices.map(price => Number(price.price || 0)));
    const maxPrice = Math.max(...prices.map(price => Number(price.price || 0)));
    return minPrice === maxPrice 
        ? `${formatNumber(minPrice)}₪`
        : `${formatNumber(maxPrice)}₪ - ${formatNumber(minPrice)}`;
};

export const calculateSaleValidity = (plan: SubscriptionPlan): string => {
    if(!plan.saleStart || !plan.saleEnd) return '-';
    return `${formatDate(plan.saleStart)} - ${formatDate(plan.saleEnd)}`;
};

export const calculatePercentage = (plan: SubscriptionPlan): number => {
    return formatNumber(((plan.amount - plan.amountAvailable) / plan.amount) * 100) || 0;
};
